import React from "react"
import style from "./Footer.module.css"

export default function Footer(){

    return(
        <div className={style.container}>
            <img src="https://un-defined.hotglue.me/?start.head.156825781149" alt='img2' className={style.sunfooter}/>
            <img src='https://www.pngkit.com/png/full/100-1005708_mountains-grid-hearst-castle-neptune-pool.png' alt='img' width="100%" className={style.imgfooter} ></img>
        </div>
    )    
}